"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PII = exports.Status = exports.Role = void 0;
var Role;
(function (Role) {
    Role["ASSISTANT"] = "assistant";
    Role["USER"] = "user";
    Role["SYSTEM"] = "system";
})(Role || (exports.Role = Role = {}));
var Status;
(function (Status) {
    Status["ERROR"] = "error";
    Status["PROFANITY"] = "profanity";
    Status["PERSONAL"] = "personal";
    Status["INAPPROPRIATE"] = "inappropriate";
    Status["OK"] = "ok";
    Status["UNKNOWN"] = "unknown";
    Status["EMAIL"] = "email";
    Status["ADDRESS"] = "address";
    Status["PHONE"] = "phone";
})(Status || (exports.Status = Status = {}));
exports.PII = [Status.EMAIL, Status.ADDRESS, Status.PHONE];
